// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__qS+Kq","hand":"Home_hand__JEojI","wave":"Home_wave__E6pgS"};